import { render } from "./FieldErrorMessage.vue?vue&type=template&id=bec9f220"
import script from "./FieldErrorMessage.vue?vue&type=script&lang=js"
export * from "./FieldErrorMessage.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__